
import React, { useRef } from "react";
import styled from "styled-components";

import emailjs from "@emailjs/browser";
import webdevelopment from "../Assets/ContactUs1.jpg";

// ✅ Wrapper
const Wrap = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

// ✅ Hero Section Image
const HeroImage = styled.img`
  width: 100%;
  height: 380px;
  object-fit: cover;

  @media (max-width: 768px) {
    height: 240px;
  }

  @media (max-width: 480px) {
    height: 180px;
  }
`;

// ✅ Contact Section
const ContactSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 60px;
  padding: 50px 20px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 40px;
  }
`;

// ✅ Left Side Text
const ContactInfo = styled.div`
  flex: 1;
  min-width: 320px;
  max-width: 500px;
`;

const Heading = styled.h1`
  font-size: 36px;
  color: darkblue;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    font-size: 28px;
    text-align: center;
  }
`;

const SubHeading = styled.p`
  font-size: 16px;
  color: #555;
  margin-bottom: 30px;
  line-height: 1.6;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const InfoItem = styled.div`
  margin-bottom: 20px;

  h3 {
    font-size: 20px;
    margin-bottom: 5px;
    color: #222;
  }

  p {
    font-size: 16px;
    color: #444;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;

// ✅ Contact Form
const Form = styled.form`
  flex: 1;
  min-width: 320px;
  max-width: 500px;
  background: #fff;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const Label = styled.label`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 6px;
  display: block;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  margin-bottom: 18px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: 0.3s;

  &:focus {
    border-color: #007bff;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  height: 120px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  margin-bottom: 18px;
  resize: none;
  transition: 0.3s;

  &:focus {
    border-color: #007bff;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 14px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background: linear-gradient(90deg, #ff512f, #dd2476);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    opacity: 0.9;
  }
`;

const ContactUs = () => {
 
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_sf6fm35", // Service ID
        "template_m4sqqwk", // Template ID
        form.current,
        "gzXtCmAs8GemfKAxI" // Public Key
      )
      .then(
        (result) => {
          alert("✅ Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("❌ Failed to send message. Try again!");
          console.error(error.text);
        }
      );
  };

  return (
    <Wrap>
      {/* Hero Image */}
      <HeroImage src={webdevelopment} alt="Contact Banner" />

      {/* Contact Section */}
      <ContactSection>
        {/* Left Side Info */}
        <ContactInfo>
          <Heading>Get in Touch</Heading>
          <SubHeading>
            Have questions or need help? Contact us via email, phone, or by filling out the form below.
          </SubHeading>

          <InfoItem>
            <h3>📍 Visit Us:</h3>
            <p>Al Hafeez Suits Gullberg 3 Lahore Cantt.</p>
          </InfoItem>

          <InfoItem>
            <h3>📧 Mail Us:</h3>
            <p>saqibali445566ali@gmail.com</p>
          </InfoItem>

          <InfoItem>
            <h3>📞 Call Us:</h3>
            <p>+923015600026</p>
          </InfoItem>
        </ContactInfo>

        {/* Right Side Form */}
        <Form ref={form} onSubmit={sendEmail}>
          <Label>Name *</Label>
          <Input type="text" name="user_name" placeholder="Enter your name" required />

          <Label>Email *</Label>
          <Input type="email" name="user_email" placeholder="Enter your email" required />

          <Label>Message *</Label>
          <TextArea name="message" placeholder="Type your message..." maxLength="2000" required />

          <Button type="submit">Send Message</Button>
        </Form>
      </ContactSection>
    </Wrap>
  );
};

export default ContactUs;
